import React from "react";
import { Link } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { SITE } from "@/data/site";

export default function NotFound() {
  return (
    <Layout>
      <title data-head="1">404 — Stránka nenalezena | Extreme Teambuilding</title>
      <meta data-head="1" name="robots" content="noindex,nofollow" />
      <div className="max-w-3xl mx-auto px-4 py-28 text-center" data-testid="not-found-page">
        <p className="font-mono text-amber text-sm font-bold tracking-[0.3em]">ERROR 404</p>
        <h1 className="font-display font-extrabold uppercase tracking-tight text-white text-4xl sm:text-5xl mt-4">Tenhle checkpoint neexistuje.</h1>
        <p className="text-mist mt-5 max-w-md mx-auto">
          Stránka, kterou hledáte, se přesunula nebo nikdy neexistovala. Zpátky na trasu vás navede úvodní stránka.
        </p>
        <Link to="/" className="inline-block mt-8 bg-amber hover:bg-amberdark text-white font-display font-bold uppercase tracking-wide px-8 py-4 transition-colors" data-testid="not-found-home-link">
          Zpět na úvod
        </Link>
      </div>
    </Layout>
  );
}
